<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="formValues$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="onboarding"
        >
          <span class="fs-3">{{ 'general.onboarding' | translate }} </span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="onboarding">
      <ng-container
        *ngFor="let slide of slides.controls; let i = index"
        formArrayName="slides"
      >
        <div [formGroupName]="i">
          <h4>{{ 'general.slide' | translate }} #{{ i + 1 }}</h4>
          <div class="mb-4">
            <label class="form-label">
              {{ 'general.image' | translate }}
            </label>
            <div class="row justify-content-between">
              <div class="col-lg-6 col-xl-3 mb-2 mb-lg-0">
                <img
                  *ngIf="slide.controls.imagePath.value"
                  class="rounded img-fluid"
                  [src]="staticAssetBaseUrl + slide.controls.imagePath.value"
                  alt="{{ 'wcag.onboardingImage' | translate }}"
                />
              </div>
              <div
                class="col-lg offset-xl-3"
                [canSee]="[accessRights.Settings_write]"
                [canSee]="[accessRights.ConfigurationOptions_write]"
              >
                <upload-file
                  (onSubmitFile)="onSubmitImage($event, i)"
                  [imageSize]="'500x450 px'"
                ></upload-file>
              </div>
            </div>
          </div>

          <fieldset class="row g-2 mb-4">
            <legend class="form-label" id="titleLabel{{ i + 1 }}">
              {{ 'general.title' | translate }}
            </legend>
            <div
              class="col-lg-6"
              *ngIf="availableLanguages['nl']"
              [formGroup]="slide.controls.nl"
            >
              <div class="input-group">
                <div class="input-group-text">
                  <span
                    class="flag flag-nl"
                    role="img"
                    id="flag-nl-d{{ i + 1 }}"
                    attr.aria-label="{{ 'wcag.nl' | translate }}"
                  ></span>
                </div>

                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="titleLabel{{ i + 1 }} flag-nl-d{{
                    i + 1
                  }}"
                  formControlName="title"
                  [attr.aria-invalid]="
                    slide.controls.nl.controls.title.dirty &&
                    slide.controls.nl.controls.title.invalid
                      ? 'true'
                      : null
                  "
                />
              </div>
            </div>

            <div
              class="col-lg-6"
              *ngIf="availableLanguages['en']"
              [formGroup]="slide.controls.en"
            >
              <div class="input-group">
                <div class="input-group-text">
                  <span
                    class="flag flag-en"
                    role="img"
                    id="flag-en-d{{ i + 1 }}"
                    attr.aria-label="{{ 'wcag.en' | translate }}"
                  ></span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="titleLabel{{ i + 1 }} flag-en-d{{
                    i + 1
                  }}"
                  formControlName="title"
                  [attr.aria-invalid]="
                    slide.controls.en.controls.title.dirty &&
                    slide.controls.en.controls.title.invalid
                      ? 'true'
                      : null
                  "
                />
              </div>
            </div>

            <div
              class="col-lg-6"
              *ngIf="availableLanguages['de']"
              [formGroup]="slide.controls.de"
            >
              <div class="input-group">
                <div class="input-group-text">
                  <span
                    class="flag flag-de"
                    role="img"
                    id="flag-de-d{{ i + 1 }}"
                    attr.aria-label="{{ 'wcag.de' | translate }}"
                  ></span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="titleLabel{{ i + 1 }} flag-de-d{{
                    i + 1
                  }}"
                  formControlName="title"
                  [attr.aria-invalid]="
                    slide.controls.de.controls.title.dirty &&
                    slide.controls.de.controls.title.invalid
                      ? 'true'
                      : null
                  "
                />
              </div>
            </div>

            <div
              class="col-lg-6"
              *ngIf="availableLanguages['fr']"
              [formGroup]="slide.controls.fr"
            >
              <div class="input-group">
                <div class="input-group-text">
                  <span
                    class="flag flag-fr"
                    role="img"
                    id="flag-fr-d{{ i + 1 }}"
                    attr.aria-label="{{ 'wcag.fr' | translate }}"
                  ></span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="titleLabel{{ i + 1 }} flag-fr-d{{
                    i + 1
                  }}"
                  formControlName="title"
                  [attr.aria-invalid]="
                    slide.controls.fr.controls.title.dirty &&
                    slide.controls.fr.controls.title.invalid
                      ? 'true'
                      : null
                  "
                />
              </div>
            </div>
          </fieldset>
          <fieldset class="row g-2 mb-4">
            <legend class="form-label" id="descLabel{{ i + 1 }}">
              {{ 'general.description' | translate }}
            </legend>
            <div
              class="col-lg-6"
              *ngIf="availableLanguages['nl']"
              [formGroup]="slide.controls.nl"
            >
              <div class="input-group">
                <div class="input-group-text">
                  <span
                    class="flag flag-nl"
                    role="img"
                    id="flag-nl-dn{{ i + 1 }}"
                    attr.aria-label="{{ 'wcag.nl' | translate }}"
                  ></span>
                </div>

                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="descLabel{{ i + 1 }} flag-nl-dn{{
                    i + 1
                  }}"
                  formControlName="description"
                  [attr.aria-invalid]="
                    slide.controls.nl.controls.description.dirty &&
                    slide.controls.nl.controls.description.invalid
                      ? 'true'
                      : null
                  "
                />
              </div>
            </div>
            <div
              class="col-lg-6"
              *ngIf="availableLanguages['en']"
              [formGroup]="slide.controls.en"
            >
              <div class="input-group">
                <div class="input-group-text">
                  <span
                    class="flag flag-en"
                    role="img"
                    id="flag-en-de{{ i + 1 }}"
                    attr.aria-label="{{ 'wcag.en' | translate }}"
                  ></span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="descLabel{{ i + 1 }} flag-en-de{{
                    i + 1
                  }}"
                  formControlName="description"
                  [attr.aria-invalid]="
                    slide.controls.en.controls.description.dirty &&
                    slide.controls.en.controls.description.invalid
                      ? 'true'
                      : null
                  "
                />
              </div>
            </div>
            <div
              class="col-lg-6"
              *ngIf="availableLanguages['de']"
              [formGroup]="slide.controls.de"
            >
              <div class="input-group">
                <div class="input-group-text">
                  <span
                    class="flag flag-de"
                    role="img"
                    id="flag-de-dd{{ i + 1 }}"
                    attr.aria-label="{{ 'wcag.de' | translate }}"
                  ></span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="descLabel{{ i + 1 }} flag-de-dd{{
                    i + 1
                  }}"
                  formControlName="description"
                  [attr.aria-invalid]="
                    slide.controls.de.controls.description.dirty &&
                    slide.controls.de.controls.description.invalid
                      ? 'true'
                      : null
                  "
                />
              </div>
            </div>
            <div
              class="col-lg-6"
              *ngIf="availableLanguages['fr']"
              [formGroup]="slide.controls.fr"
            >
              <div class="input-group">
                <div class="input-group-text">
                  <span
                    class="flag flag-fr"
                    role="img"
                    id="flag-fr-df{{ i + 1 }}"
                    attr.aria-label="{{ 'wcag.fr' | translate }}"
                  ></span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="descLabel{{ i + 1 }} flag-fr-df{{
                    i + 1
                  }}"
                  formControlName="description"
                  [attr.aria-invalid]="
                    slide.controls.fr.controls.description.dirty &&
                    slide.controls.fr.controls.description.invalid
                      ? 'true'
                      : null
                  "
                />
              </div>
            </div>
          </fieldset>

          <div class="d-flex justify-content-end pb-3">
            <button
              class="btn btn-soft-secondary"
              type="button"
              (click)="removeSlide(i)"
              [canSee]="[accessRights.ConfigurationOptions_delete]"
            >
              {{ 'general.removeSlide' | translate }}
            </button>
          </div>
        </div>
        <hr class="card-table" />
      </ng-container>

      <div class="form-footer sticky-bottom justify-content-between">
        <button
          class="btn btn-soft-primary"
          type="button"
          (click)="addSlide()"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.addSlide' | translate }}
        </button>
        <button
          *ngIf="slides.length > 0"
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
